import { render, staticRenderFns } from "./Group-View-File.vue?vue&type=template&id=6b961bc4&scoped=true&"
import script from "./Group-View-File.vue?vue&type=script&lang=js&"
export * from "./Group-View-File.vue?vue&type=script&lang=js&"
import style0 from "./Group-View-File.vue?vue&type=style&index=0&id=6b961bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b961bc4",
  null
  
)

export default component.exports